export default __webpack_public_path__ + "2e88fce.png";